import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as IconProjectSvg }  from '../../assets/icons/icon_project_blue.svg';

const ProjectIcon=(props)=>{
    return <Icon component={() => <IconProjectSvg />} {...props}/>
}

export default ProjectIcon;